import {FacilityEntityT} from '../models/facilities/facilities-provider';

export const formatCoordinates = (obj: FacilityEntityT) => {
  const result = [];

  if (obj.hasOwnProperty('lat')) {
    // Обрабатываем latitude
    if (typeof obj.lat === 'number') {
      const latStr = obj.lat.toString();
      result.push(latStr.slice(0, 2) + '.' + latStr.slice(2));
    } else if (typeof obj.lat === 'string') {
      // @ts-expect-error
      if (obj.lat.includes('.')) {
        result.push(obj.lat);
      } else {
        // @ts-expect-error
        result.push(obj.lat.slice(0, 2) + '.' + obj.lat.slice(2));
      }
    }
  }

  if (obj.hasOwnProperty('lng')) {
    if (typeof obj.lng === 'number') {
      const lngStr = obj.lng.toString();
      result.push(lngStr.slice(0, 2) + '.' + lngStr.slice(2));
    } else if (typeof obj.lng === 'string') {
      // @ts-expect-error
      if (obj.lng.includes('.')) {
        result.push(obj.lng);
      } else {
        // @ts-expect-error
        result.push(obj.lng.slice(0, 2) + '.' + obj.lng.slice(2));
      }
    }
  }

  return result;
}

export const getLepIcon = (color = '#1E88E5', poleColor = '#555') => ({
  iconLayout: 'default#image',
  iconImageHref: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(`
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="lightning_gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#00DCFC" stop-opacity="1" />
          <stop offset="100%" stop-color="#0079DE" stop-opacity="1" />
        </linearGradient>
      </defs>
      <path 
        d="M20.25 4.5H15.75L10.125 19.125H15.75L12.375 31.5L25.875 13.5H18L25.875 4.5H20.25Z" 
        fill="url(#lightning_gradient)" 
        stroke="#333333" 
        stroke-width="1.5" 
        stroke-linejoin="round" 
      />
    </svg>
  `),
  iconImageSize: [36, 36], // Увеличенный размер
  iconImageOffset: [-18, -36], // Новое смещение для увеличенной иконки
});